<template>
  <div id="app">
    <commonHeader :opacity="topOpacity" pathName="home"></commonHeader>
    <div class="the_index_top_body"></div>
    <div class="the_index_content_body">
      <div class="the_index_content_left_bg">
        <img src="@/assets/img/index-left-bg.png?v=1.0.0.1" />
      </div>
      <div class="">
        <carousel :per-page="1" @transition-end="endAnime" :autoplay="true" :loop="true" :autoplayTimeout="5000" :autoplayHoverPause="false" :paginationEnabled="true" @page-change="swiperPageChange" paginationActiveColor="#367ce4">
          <slide>
              <div class="the_index_swiper_slide common_body">
                <div class="fl the_index_swiper_left_text">
                  <h2 class="the_index_swiper_left_text_title anime" :class="{animeted:swiperAnimeSlide===0,fadeIn:swiperAnimeSlide===0}" :style="{animationDelay:animeDelay*2+'s'}">信用・信頼は<br />ビジネス成り立ちの基礎</h2>
                  <p class="the_index_swiper_left_text_content anime" :class="{animeted:swiperAnimeSlide===0,fadeIn:swiperAnimeSlide===0}" :style="{animationDelay:animeDelay*4+'s'}">“有言実行”、お客様からの御満足と御信頼を得る事を最も重視し、頂いた仕事は必ずやり遂げ、常に高品質で低コストのサービスを提供する事により、お客様との厚い信頼関係を構築して参ります。</p>
                </div>
                <div class="fr the_index_swiper_right_bg_body">
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-7.png?v=1.0.0.1" :style="{animationDelay:animeDelay*6+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-6.png?v=1.0.0.1" :style="{animationDelay:animeDelay*5+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-5.png?v=1.0.0.1" :style="{animationDelay:animeDelay*4+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-4.png?v=1.0.0.1" :style="{animationDelay:animeDelay*3+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-1.png?v=1.0.0.1" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-2.png?v=1.0.0.1" :style="{animationDelay:animeDelay*1+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===0,bounceIn:swiperAnimeSlide===0}" src="@/assets/img/swiperBg/1-3.png?v=1.0.0.1" :style="{animationDelay:animeDelay*2+'s'}" />
                </div>
              </div>
          </slide>
          <slide>
              <div class="the_index_swiper_slide common_body">
                <div class="fl the_index_swiper_left_text">
                  <h2 class="the_index_swiper_left_text_title anime" :class="{animeted:swiperAnimeSlide===1,fadeIn:swiperAnimeSlide===1}" :style="{animationDelay:animeDelay*2+'s'}">日中のグループ一体化</h2>
                  <p class="the_index_swiper_left_text_content anime" :class="{animeted:swiperAnimeSlide===1,fadeIn:swiperAnimeSlide===1}" :style="{animationDelay:animeDelay*4+'s'}">日本法人のTHEを中心としてグループ全体が一体化しています。日本THEの代表取締役が中国THEの代表取締役を兼務し、経営・管理に参加しています。日中で「一元管理、開発基準統一、リソースの共有、グループ内人材シフト」を実施しています。</p>
                </div>
                <div class="fr the_index_swiper_right_bg_body">
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===1,bounceIn:swiperAnimeSlide===1}" src="@/assets/img/swiperBg/2-1.png?v=1.0.0.1" :style="{animationDelay:animeDelay*1+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===1,bounceIn:swiperAnimeSlide===1}" src="@/assets/img/swiperBg/2-2.png?v=1.0.0.1" :style="{animationDelay:animeDelay*2+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===1,bounceIn:swiperAnimeSlide===1}" src="@/assets/img/swiperBg/2-3.png?v=1.0.0.1" :style="{animationDelay:animeDelay*3+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===1,bounceIn:swiperAnimeSlide===1}" src="@/assets/img/swiperBg/2-4.png?v=1.0.0.1" :style="{animationDelay:animeDelay*4+'s'}" />
                </div>
              </div>
          </slide>
          <slide>
              <div class="the_index_swiper_slide common_body">
                <div class="fl the_index_swiper_left_text">
                  <h2 class="the_index_swiper_left_text_title anime" :class="{animeted:swiperAnimeSlide===2,fadeIn:swiperAnimeSlide===2}" :style="{animationDelay:animeDelay*2+'s'}">人材こそが最大の財産</h2>
                  <p class="the_index_swiper_left_text_content anime" :class="{animeted:swiperAnimeSlide===2,fadeIn:swiperAnimeSlide===2}" :style="{animationDelay:animeDelay*4+'s'}">徹底した教育により、お客様へのサービス精神を持ち、日本のビジネス習慣を身に付け、豊富な技術ノウハウ・業務ノウハウを有した、真のSE人材を育成して参ります。</p>
                </div>
                <div class="fr the_index_swiper_right_bg_body">
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===2,bounceIn:swiperAnimeSlide===2}" src="@/assets/img/swiperBg/3-1.png?v=1.0.0.1" :style="{animationDelay:animeDelay*1+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===2,bounceIn:swiperAnimeSlide===2}" src="@/assets/img/swiperBg/3-2.png?v=1.0.0.1" :style="{animationDelay:animeDelay*2+'s'}" />
                  <img class="the_index_swiper_right_bg_img anime" :class="{animeted:swiperAnimeSlide===2,bounceIn:swiperAnimeSlide===2}" src="@/assets/img/swiperBg/3-3.png?v=1.0.0.1" :style="{animationDelay:animeDelay*3+'s'}" />
                </div>
              </div>
          </slide>
        </carousel>
        <div class="banner-01"></div>
        <div class="banner-02"></div>
      </div>
      <div class="the_index_f2_body common_body">
        <h3 class="the_index_h3 the_index_f2_h3" data-aos="fade-up">サービス内容</h3>
        <h4 class="the_index_h4_en the_index_f2_h3" data-aos="fade-up">Service</h4>
        <div class="the_index_f2_content_body">
          <el-row :gutter="40" data-aos="fade-up">
            <el-col :span="24" :lg="8">
              <a href="javascript:;" class="the_index_f2_box">
                <div><img class="the_index_f2_img" src="@/assets/img/f2/f1-1.png?v=1.0.0.1" /></div>
                <div class="the_index_f2_content_title">開発・保守</div>
                <div class="the_index_f2_content_text">お客様のご要望に応じた「OS、DB、言語、ツール、フレームワーク」によるソフトウエア開発・保守サービス。 汎用コンピュータの開発、コンバージョン、マイグレーションサービス。</div>
              </a>
            </el-col>
            <el-col :span="24" :lg="8">
              <a href="javascript:;" class="the_index_f2_box">
                <div><img class="the_index_f2_img" src="@/assets/img/f2/f1-2.png?v=1.0.0.1" /></div>
                <div class="the_index_f2_content_title">オフショア開発</div>
                <div class="the_index_f2_content_text">お客様のご要望を基づくオフショア開発。お客様のご要望によるラボ契約での運用監視サービス。 中国進出の日本企業向けのシステム開発・保守サービス。</div>
              </a>
            </el-col>
            <el-col :span="24" :lg="8">
              <a href="javascript:;" class="the_index_f2_box">
                <div><img class="the_index_f2_img" src="@/assets/img/f2/f1-3.png?v=1.0.0.1" /></div>
                <div class="the_index_f2_content_title">iOS・Android</div>
                <div class="the_index_f2_content_text">ブロックチェーン開発、CRMシステム開発、組込み系システム開発、コンサルティング、データ‐マイニング、OCR開発、ウェブ‐クローラーなど</div>
              </a>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="the_index_f3_body common_body">
        <h3 class="the_index_h3" data-aos="fade-up">開発実績</h3>
        <h4 class="the_index_h4_en" data-aos="fade-up">Customer Case</h4>
        <div class="the_index_f3_content_body">
          <div class="the_index_f3_content_box_margin" data-aos="fade-up">
            <a href="/service?id=6" class="the_index_f3_content_box type_1">
              <div class="the_index_f3_content_title">CRMシステム</div>
              <div class="the_index_f3_content_text">人とシステムの融合による業務効率化を目指し、従来パケッジの課題改善、コスト削減等を目的としてのシステムを構築する。<br />
              お客さまのご要望にきめ細かく対応する個別開発と、あらゆるお客さまに対応できるCRMパッケージの保守・運用のアウトソーシングサービスなど、適用業務や目的を十分に分析をした上で、お客様に最適なソリューションをご提供します。</div>
            </a>
          </div>
          <div class="the_index_f3_content_box_margin" data-aos="fade-up">
            <a href="/service?id=7" class="the_index_f3_content_box type_2">
              <div class="the_index_f3_content_title">WEBシステム</div>
              <div class="the_index_f3_content_text">安定性・効率性・拡張性に優れたフレームワークを用いた生産性の高いシステム開発を行っています。<br />
              WEB環境のみならず、既存システムとのWEB連携やWEBサービス化など、お客様に最も有効なシステム環境をWebソリューションとしてご提供します。<br />
              お客様のご要望に柔軟に対応する最適なシステムについて、各種携帯、ブラウザ等、各ベンダの端末に対応したフロントからバックエンドまでのWebシステムをご提供します。</div>
            </a>
          </div>
          <div class="the_index_f3_content_box_margin" data-aos="fade-up">
            <a href="/service?id=8" class="the_index_f3_content_box type_3">
              <div class="the_index_f3_content_title">管理システム</div>
              <div class="the_index_f3_content_text">お客様に新たな価値を提供できる技術力を強みとし、設立1年という短期間で大手機関やSIベンダーからの信頼を得ることに成功しました。<br />
              弊社は、お客様と共に、銀行、企業のシステム開発・保守に携わり、業務知識をよく知る、高度な管理システム開発力を保有するプロ集団として、お客様からの信頼をいただいておりますだ。 </div>
            </a>
          </div>
          <div class="the_index_f3_content_box_margin" data-aos="fade-up">
            <a href="/service?id=9" class="the_index_f3_content_box type_4">
              <div class="the_index_f3_content_title">コンサルティング</div>
              <div class="the_index_f3_content_text">現状のシステムに対する非効率化の解消や新たに導入を計画されているシステムについて、分析・提案するコンサルティングを行っています。<br />
              クライアントとコミュニケーションをとり、その中でクライアントの経営・管理・業務を理解し、そこで発生している問題点やその真因たる課題を把握し、クライアントが実行できるプランを立てて実行に移し、数ある目標を達成していくことでシステムの計画立案、設計の支援を行います。</div>
            </a>
          </div>
        </div>
        <div class="tc" data-aos="fade-up">
          <a href="/service-list" class="the_index_common_more_btn"><span class="the_index_common_more_btn_text">もっと見る</span><i class="el-icon-right"></i></a>
        </div>
      </div>
      <div class="the_index_f4_body">
        <div class="the_index_f4_content_body">
          <div class="the_index_f4_content common_body clearfix">
            <div class="the_index_f4_l_body" data-aos="fade-right">
              <div class="the_index_f4_l_title">THEについて</div>
              <div class="the_index_f4_l_subtitle">About us</div>
              <div class="the_index_f4_l_text">
                人材とサービス精神でお客様と強固且長期安定的なパートナー関係を構築して参ります。 弊社は「人材・信頼・共生・効率・創造」を礎に、未来に向けて優れたソリューションを持ち、 コンサルティングから運用・アウトソーシングまで、一流のサービスを提供する国際的情報サービスグループ企業を目指して参ります。
              </div>
              <div class="mt25"><a href="/about-us" class="the_index_white_btn">詳しく見る</a></div>
            </div>
            <div class="the_index_f4_r_body" data-aos="fade-left">
              <img src="@/assets/img/f4/the.png?v=1.0.0.1" />
            </div>
          </div>
        </div>
      </div>
      <!--
      <div class="the_index_news_body common_body">
        <h3 class="the_index_h3" data-aos="fade-up">お知らせ</h3>
        <h4 class="the_index_h4_en" data-aos="fade-up">THE News</h4>
        <div class="the_index_news_content_body" v-loading="newsLoading">
          <el-row :gutter="40" v-if="list">
            <el-col :sm="12" :span="24" v-for="(item,index) in list" v-bind:key="index" v-show="index<2" data-aos="fade-up">
              <a :href="'/article?id='+item.id" class="the_index_news_content_box">
                <div class="the_index_news_content_img_box">
                  <img v-if="item.img" :src="item.img" />
                  <img v-else src="@/assets/img/news.jpg?v=1.0.0.1" />
                </div>
                <div class="the_index_news_content_info_box">
                  <div class="the_index_news_title">{{item.title?item.title:'無名'}}</div>
                  <div class="the_index_news_time">{{item.time?item.time:'2000-1-1 00:00:00'}}</div>
                </div>
              </a>
            </el-col>
          </el-row>
          <div class="tc" data-aos="fade-right">
            <a href="/news-list" class="the_index_common_more_btn"><span class="the_index_common_more_btn_text">もっと見る</span><i class="el-icon-right"></i></a>
          </div>
        </div>
      </div>
      -->
    </div>
    <commonFooter></commonFooter>
  </div>
</template>

<script>
import commonHeader from '../../components/header.vue'
import commonFooter from '../../components/footer.vue'
import { Carousel, Slide } from 'vue-carousel'
import { authApi } from '@/api'
export default {
  data() {
    return {
      list: null,
      swiperslide: 0,
      swiperAnimeSlide: 0,
      animeDelay: 0.1,
      page: 1,
      newsLoading: true,
      topOpacity: true,
      swiperChangeCheckTimer: null
    }
  },
  components: {
    commonHeader,
    commonFooter,
    Carousel,
    Slide
  },
  mounted() {
    this.getNews()
    window.addEventListener('scroll', this.menuTop)
  },
  updated() {
    const dots = document.getElementsByClassName('VueCarousel-dot')
    for (let index = 0; index < dots.length; index += 1) {
      const element = dots[index]
      element.title = ''
    }
  },
  methods: {
    // 用于修复幻灯片有时候不执行动画结束
    checkSwiper() {
      this.swiperChangeCheckTimer = setTimeout(() => {
        this.endAnime()
      }, 1200)
    },
    menuTop() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop >= (window.innerWidth < 1400 ? 5 : 100)) {
        this.topOpacity = false
      } else {
        this.topOpacity = true
      }
    },
    getNews() {
      let params = {
        page: this.page
      }
      authApi.news(params).then(res => {
        this.newsLoading = false
        if (res.data.code === 1) {
          this.list = res.data.list
        }
      })
    },
    endAnime() {
      clearTimeout(this.swiperChangeCheckTimer)
      this.swiperAnimeSlide = this.swiperslide
    },
    swiperPageChange(sp) {
      this.swiperslide = sp
      clearTimeout(this.swiperChangeCheckTimer)
      this.checkSwiper()
    }
  }
}
</script>

<style scoped>
.the_index_top_body {
  overflow: hidden;
  color: #fff;
  height: 814px;
  background-position: top center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-image: url('../../assets/img/index-top-bg.png?v=1.0.0.1'),
    linear-gradient(122deg, rgb(43, 107, 223) 0%, rgb(73, 154, 235) 100%);
    background-size: cover;
}
.the_index_content_body {
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 860px;
  margin-top: -814px;
  position: relative;
}
.the_index_content_left_bg {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 210px;
}
.the_index_carousel_body {
  position: relative;
  z-index: 2;
}
.the_index_swiper_slide {
  height: 855px;
}
.the_index_swiper_left_text {
  margin-top: 305px;
  margin-left: 35px;
  width: 528px;
  color: #fff;
}
.the_index_swiper_left_text_title {
  font-weight: bold;
  font-size: 48px;
}
.the_index_swiper_left_text_content {
  font-size: 16px;
  margin-top: 30px;
}
.the_index_swiper_right_bg_body {
  width: 680px;
  height: 526px;
  position: relative;
  z-index: 1;
  margin-top: 273px;
}
.the_index_swiper_right_bg_body .the_index_swiper_right_bg_img {
  position: absolute;
  left: 0;
  top: 0;
}
.the_index_h3 {
  color: #202020;
  font-size: 22px;
  text-align: center;
  font-weight: bold;
}
.the_index_f2_body {
  padding-top: 40px;
}
.the_index_f2_content_body {
  padding-top: 30px;
  padding-bottom: 20px;
}
.the_index_f2_box {
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
  min-height: 424px;
  text-align: center;
  padding: 0 26px;
  display: block;
  margin-bottom: 20px;
  /* transition: all 0.5s; */
  position: relative;
}
.the_index_f2_box:hover {
  background-image: linear-gradient(45deg, #6859ea 0, #6acbe0 100%);
  color: #fff;
}
/*  */
/* .the_index_f2_box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: all 0.3s;
}
.the_index_f2_box:hover::before {
  opacity: 0;
  transform: scale(0.5, 0.5);
}
.the_index_f2_box::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  transition: all 0.3s;
  border: 1px solid rgb(114, 192, 255);
  transform: scale(1.2, 1.2);
  border-radius: 5px;
}
.the_index_f2_box:hover::after {
  opacity: 1;
  transform: scale(1, 1);
} */
/*  */
.the_index_f2_content_title {
  font-size: 24px;
  margin-bottom: 22px;
}
.the_index_f2_content_text {
  font-size: 15px;
  line-height: 28px;
}
.the_index_common_more_btn {
  border-radius: 10px;
  background-color: rgb(45, 199, 237);
  width: 220px;
  height: 58px;
  text-align: center;
  line-height: 58px;
  display: inline-block;
  color: #fff;
  font-size: 20px;
  transition: 0.3s;
}
.the_index_common_more_btn:hover {
  background-color: rgb(54, 124, 228);
}
.the_index_common_more_btn_text {
  padding-right: 22px;
}
.the_index_f3_body {
  padding-top: 20px;
  padding-bottom: 30px;
}
.the_index_f3_content_body {
  margin-top: 30px;
}
.the_index_f3_content_box_margin {
  margin-bottom: 30px;
}
.the_index_f3_content_box {
  padding: 34px 40px 34px 222px;
  background-position: left center;
  background-repeat: no-repeat;
  display: block;
  transition: 0.3s;
  border-radius: 10px;
}
.the_index_f3_content_box:hover {
  background-color: #fff;
  box-shadow: 0px 7px 33px 0px rgba(12, 74, 89, 0.07);
  transform: translateY(-5px);
}
.the_index_f3_content_box.type_1 {
  background-image: url('../../assets/img/f3/1.png?v=1.0.0.1');
}
.the_index_f3_content_box.type_2 {
  background-image: url('../../assets/img/f3/2.png?v=1.0.0.1');
}
.the_index_f3_content_box.type_3 {
  background-image: url('../../assets/img/f3/3.png?v=1.0.0.1');
}
.the_index_f3_content_box.type_4 {
  background-image: url('../../assets/img/f3/4.png?v=1.0.0.1');
}
.the_index_f3_content_title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.the_index_f3_content_text {
  font-size: 15px;
  line-height: 30px;
}
.the_index_f4_body {
  padding: 95px 0;
  background-image: url('../../assets/img/f4/top.png?v=1.0.0.1'),
    url('../../assets/img/f4/bottom.png?v=1.0.0.1');
  background-repeat: no-repeat;
  background-position: top center, bottom center;
}
.the_index_f4_content_body {
  background-color: #418de8;
}
.the_index_f4_content {
  color: #fff;
  padding: 0 40px;
}
.the_index_f4_l_body {
  float: left;
  width: 680px;
}
.the_index_f4_l_title {
  font-size: 30px;
}
.the_index_f4_l_subtitle {
  font-size: 24px;
}
.the_index_f4_l_text {
  font-size: 15px;
  margin-top: 30px;
  line-height: 37px;
}
.the_index_f4_r_body {
  float: right;
}
.the_index_white_btn {
  border-width: 1px;
  border-color: rgb(255, 255, 255);
  border-style: solid;
  border-radius: 10px;
  display: inline-block;
  color: #fff;
  padding: 8px 10px;
  font-size: 18px;
  transition: 0.3s;
}
.the_index_white_btn:hover {
  background-color: #fff;
  color: #418de8;
}
.the_index_news_content_body {
  padding: 0 85px;
  margin-top: 30px;
  margin-bottom: 30px;
  min-height: 200px;
}
.the_index_news_content_box {
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 7px 33px 0px rgba(12, 74, 89, 0.07);
  overflow: hidden;
  margin-bottom: 35px;
  display: block;
}
.the_index_news_content_info_box {
  padding: 20px 26px 30px 26px;
}
.the_index_news_title {
  font-size: 18px;
  color: #2dc7ed;
  line-height: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.the_index_news_time {
  font-size: 16px;
}
.the_index_news_content_img_box {
  height: 240px;
  overflow: hidden;
}
.the_index_news_content_img_box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.3s;
}
.the_index_news_content_box:hover .the_index_news_content_img_box img {
  transform: scale(1.2);
}
.the_index_f2_img {
  width: auto;
  height: 185px;
  padding-top: 22px;
}
.the_index_h4_en {
  text-align: center;
}
/* media */
@media (min-width: 1921px) {
  .the_index_content_body {

  }
  .the_index_f4_body {
    background-image: none;
    padding: 60px 0;
    background-color: #418de8;
  }
}
@media (max-width: 1366px) {
  .the_index_swiper_left_text {
    margin-top: 220px;
  }
  .the_index_swiper_right_bg_body {
    margin-top: 84px;
  }
  .the_index_swiper_slide {
    height: 700px;
  }
  .the_index_f2_box {
    background-color: rgba(255, 255, 255, 1);
  }
}
@media (max-width: 1360px) {
  .the_index_content_body {
   
  }
  .the_index_swiper_slide {
    position: relative;
  }
  .the_index_swiper_left_text {
    margin-top: 80px;
    margin-left: auto;
    margin-right: auto;
    max-width: 800px;
    width: calc(100% - 20px);
    float: none;
  }
  .the_index_swiper_right_bg_body {
    width: 100%;
    max-width: 680px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    float: none;
  }
  .the_index_swiper_right_bg_body img {
    max-width: 680px;
    width: 100%;
    height: auto;
  }
  .the_index_swiper_left_text_title {
    font-size: 24px;
  }
  .the_index_swiper_left_text_content {
    font-size: 14px;
    margin-top: 15px;
  }
  .the_index_f2_box {
    padding-bottom: 20px;
  }
  .the_index_swiper_slide {
    height: auto;
  }
  .the_index_f2_body {
    padding-top: 70px;
  }
  .the_index_f3_body {
    padding-top: 40px;
  }
  .the_index_f3_body {
    padding-bottom: 40px;
  }
  .the_index_f3_content_box {
    padding: 160px 20px 34px 20px;
    background-position: center 20px;
  }
  .the_index_f3_content_title {
    text-align: center;
  }
  .the_index_news_content_body {
    padding: 0;
  }
  .the_index_f4_r_body {
    display: none;
  }
  .the_index_f4_l_body {
    flex: none;
    width: auto;
  }
  .the_index_common_more_btn {
    border-radius: 5px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
  .the_index_common_more_btn_text {
    padding-right: 14px;
  }
  .the_index_news_content_body {
    margin-bottom: 30px;
  }
  .the_index_f2_content_body {
    padding-top: 20px;
  }
  .the_index_f4_body {
    background-image: none;
    padding: 60px 0;
    background-color: #418de8;
  }
}
@media (max-width: 680px) {
  .the_index_swiper_right_bg_body {
    height: auto;
    padding-bottom: 77.35%;
  }
}
@media (max-width: 614px) {
  .the_index_f2_h3 {
    color: #fff;
  }
}
@media (max-width: 768px) {
  .the_index_f2_box {
    background-color: rgba(255, 255, 255, 1);
  }
  .the_index_h3 {
    font-size: 22px;
  }
  .the_index_f2_content_title {
    font-size: 26px;
  }
}
/* anime */
.anime {
  opacity: 0;
}
.animeted {
  opacity: 1;
  animation-duration: 0.6s;
  animation-fill-mode: both;
}
@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    -webkit-transform: scale3d(1.03, 1.03, 1.03);
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    -webkit-transform: scale3d(0.97, 0.97, 0.97);
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.bounceIn {
  -webkit-animation-duration: 0.75s;
  animation-duration: 0.75s;
  -webkit-animation-name: bounceIn;
  animation-name: bounceIn;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}
</style>
<style>
.VueCarousel-dot:focus {
  outline: none !important;
}
@media (max-width: 1366px) {
  .VueCarousel-pagination {
    width: 100%;
    text-align: center;
    margin-top: -123px;
    z-index: 10;
  }
  button:first-child.VueCarousel-dot.VueCarousel-dot--active {
    background-color: #3a3a3a !important;
  }
}
@media (max-width: 1360px) {
  .VueCarousel-pagination {
    display: none !important;
  }
}
</style>
